






























import mixins from 'vue-typed-mixins';
import DashboardUtils, { DashboardCanvas } from '@/utils/DashboardUtils';
import OversightUtils, { OversightOrganization } from '@/utils/OversightUtils';
import SurveyUtils, { SurveyGroup, Survey } from '@/utils/SurveyUtils';
import DashboardTileDisplayVue from '@/components/dashboard/DashboardTileDisplay.vue';
import { v4 as uuidv4 } from 'uuid';

export default mixins().extend({
  components: {
    DashboardTileDisplay: DashboardTileDisplayVue,
  },

  computed: {
    dashboardContext(): any {
      return {
        oversight: this.organization,
        surveygroup: this.group,
      };
    },

    organizationsOptions(): any {
      return this.organizations?.map((organization) => ({
        text: this.$translate(organization.name),
        value: organization,
      }));
    },

    organization: {
      get(): OversightOrganization | undefined {
        const id = parseInt(this.$route.query.organization as string);
        return this.organizations?.find(
          (organization) => organization.id === id
        );
      },
      async set(organization: OversightOrganization) {
        const id = parseInt(this.$route.query.organization as string);
        if (
          organization.id !== id &&
          this.$route.name === 'dashboard-oversight-organization'
        ) {
          await this.$router.push({
            name: 'dashboard-oversight-organization',
            query: {
              ...this.$route.query,
              organization: organization?.id?.toString() || '',
            },
          });
        }
      },
    },

    groupsOptions(): any {
      return this.groups?.map((group) => ({
        text: group.name,
        value: group,
      }));
    },

    group: {
      get(): SurveyGroup | undefined {
        const id = parseInt(this.$route.query.group as string);
        return this.groups?.find((group) => group.id === id);
      },
      async set(group: SurveyGroup) {
        const id = parseInt(this.$route.query.group as string);
        if (
          group.id !== id &&
          this.$route.name === 'dashboard-oversight-organization'
        ) {
          await this.$router.push({
            name: 'dashboard-oversight-organization',
            query: {
              ...this.$route.query,
              group: group?.id?.toString() || '',
            },
          });
        }
      },
    },
  },

  data(): {
    organizations?: OversightOrganization[];
    groups?: SurveyGroup[];
  } {
    return {
      organizations: undefined,
      groups: undefined,
    };
  },

  async mounted() {
    this.loadSurveyGroups();
    this.loadOrganizations();
  },

  methods: {
    async loadSurveyGroups() {
      try {
        this.groups = await SurveyUtils.api.surveyGroup.list();

        if (this.groups.length > 0 && !this.$route.query.group) {
          this.group = this.groups[0];
        }
      } catch (error) {
        this.$alert.show('mounted', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async loadOrganizations() {
      try {
        if (
          this.$session?.role?.type === 'superadmin' ||
          this.$session?.role?.type === 'admin'
        ) {
          this.organizations = await OversightUtils.api.instance.list();
        } else {
          this.organizations = await this.$session?.permissions
            .filter(
              (permission: any) =>
                permission.role.id === this.$session?.role?.id &&
                permission.role.type === 'oversight'
            )
            .map((permission: any) => permission.oversight);
        }

        if (
          this.organizations.length === 1 &&
          !this.$route.query.organization
        ) {
          this.organization = this.organizations[0];
        }
      } catch (error) {
        this.$alert.show('mounted', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
